module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fc-Gb-Hc-Ia.cf5c8c17.png";